import React from 'react'
import moment from 'moment'
import {
  Table,
  Divider,
  Input,
  Tag,
} from 'antd'
import Cell from '../../../components/Cell'
import Crud from '../../../components/Crud'
import Exception from '../../../Exception'
import { pagosSinComplementoQuery } from './query-sin-complemento'
import Api from '../../../Api'
import ComplementoPagoModal from './modal'
import { fileInfoStr } from "../../../util/fileInfoStr"
import { Prompt } from 'react-router'
import { FilesUploadProgress } from '../../../components/kernel/FilesUploadProgress'

export class SinComplementoPagoList extends React.Component {
  /**
   *
   * @param {*} props
   */
  constructor(props) {
    super(props)

    this.columns = Cell.buildList([
      { width: '10%', title: 'FACT. / REF.', dataIndex: 'info.sUUID', render: (val, record) => (
        <Tag color='purple' children={val || record.sReferencia} />
      )},
      { width: '10%', title: 'INGRESO', dataIndex: 'info.dFechaIngreso', render: (val) => (
        moment(val).format('DD MMM YY')
      )},
      { width: '10%', title: 'PAGO (OPERACIÓN)', dataIndex: 'pago.sNumeroTransferencia', render: (val) => (
        <Tag color='blue' children={val} />
      )},
      { width: '10%', title: 'APLICADO', dataIndex: 'pago.dFechaPago', render: (val) => (
        moment(val).format('DD MMM YY')
      )},
      { width: '40%', title: ' ', dataIndex: 'info.sReferencia', render: (val) => (
        <div children='' />
      )},
    ])

    this.state = {
      loading: false,
      uploading: false,
      progress: 0,
      uploadingFile: '',
      uploadCancelled: false,
      search: '',
      data: [],
      files: [],
    }
  }

  /**
   *
   */
  componentDidMount = () => {
    this.fetch()
  }

  /**
   *
   * @param {*} search
   */
  fetch = async(search = '') => {
    try {
      this.setState({ loading: true })

      const response = await Api.query(
        pagosSinComplementoQuery(Api.getProviderId(), search)
      )

      this.setState({
        data: response.data.map(pi => {
          pi.info = pi.factura || pi.facturaSub
          return pi
        }),
        loading: false,
        search,
      })
    } catch (error) {
      this.setState({
        data: [],
        loading: false,
      })
      Exception.load(error).show()
    }
  }

  /**
   *
   * @param {File} file
   */
  doUploadFile = (file) => {
    return new Promise (async (resolve, reject) => {
      try {
        const fileForm = Api.form({
          upload: file,
          tipo: 'WEB.PROV.COM.COMPLEMENTO_PAGO_XML'
        })

        const { data: upload } = await Api.post('/upload/file', fileForm)

        const { data: complemento } = await Api.post('/com/documentos/orden-compra/complemento-pago', {
          iIdArchivo: upload.iId
        })

        resolve(complemento)
      } catch (err) {
        reject(err)
      }
    })
  }

  /**
   *
   * @param {File[]} files
   */
  doUploadFiles = async (files) => {
    this.setState(state => ({
      ...state,
      uploadCancelled: false,
      uploadingFile: '',
      uploading: true,
      progress: 0,
    }))

    try {
      for (let fileIdx = 0; fileIdx < files.length; fileIdx++) {
        if (this.state.uploadCancelled) {
          return this.setState({
            uploadCancelled: false,
            uploadingFile: '',
            uploading: false,
            progress: 0,
          })
        }

        const file = files[fileIdx]

        this.setState(state => ({
          ...state,
          uploadingFile: fileInfoStr(file)
        }))

        await this.doUploadFile(file)

        this.setState(state => ({
          ...state,
          progress: +(((fileIdx + 1) / files.length) * 100).toFixed(1),
        }))
      }

      this.setState(state => ({
        ...state,
        progress: 100
      }))
    } catch (error) {
      Exception.load(error).show()
    }

    setTimeout(() => {
      this.setState(state => ({
        ...state,
        uploading: false,
        progress: 0,
      }))
    }, 2500)
  }

  /**
   *
   */
  onAdd = () => {
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = '.xml'
    input.multiple = true
    input.onchange = e => {
      if (input.files.length > 0) {
        this.doUploadFiles([...input.files])
      } else {
        this.setState({
          uploading: false,
          progress: 0,
        })
      }

      input.value = null
    }

    input.click()
  }

  /**
   *
   */
  render() {
    const tableTitle = (
      <div>
        <div>
          <Crud
            buttons={this.state.loading || this.state.uploading ?
              ['reload'] :
              ['add', 'reload']
            }
            onAdd={this.onAdd}
            onReload={() => this.fetch(this.state.search)}
          />

          <Divider type='vertical'/>
          <Input.Search
            placeholder='Buscar'
            style={{ width: 185 }}
            onSearch={value => this.fetch(value.trim())}
            allowClear
          />
        </div>

        {this.state.uploading && <>
          <Divider style={{ marginTop: 12, marginBottom: 12 }} />
          <FilesUploadProgress
            uploadingFile={this.state.uploadingFile}
            progress={this.state.progress}
            cancelled={this.state.uploadCancelled}
            onConfirmCancel={() => this.setState({ uploadCancelled: true })}
          />
        </>}
      </div>
    )

    return (
      <div style={{ flex: 1 }}>
        <Prompt
          when={this.state.uploading}
          message='¿Estás seguro de que deseas salir de esta página?'
        />

        <ComplementoPagoModal
          ref={ref => this.complementoPago = ref}
          onCancel={() => this.fetch(this.state.search)}
          onSolicitada={() => this.fetch(this.state.search)}
          onSave={() => this.fetch(this.state.search)}
        />

        <Table
          rowKey='iId'
          size='small'
          rowClassName='row-pure'
          dataSource={this.state.data}
          columns={this.columns}
          loading={this.state.loading}
          pagination={false}
          title={() => tableTitle}
        />
      </div>
    )
  }
}
